import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';

function escapeCsvCell(v) {
  const s = v == null ? '' : String(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function rowsToCsv(rows) {
  return rows.map((r) => r.map(escapeCsvCell).join(',')).join('\n');
}

/**
 * @param {object} data — from ModuleAssessmentAuditPanel: moduleTitle, moduleId, filenameBase, summaryTaskRows, expectedIacTaskRows
 */
export function downloadModuleAuditCsv(data) {
  const lines = [];
  lines.push(`Module,${escapeCsvCell(data.moduleTitle)}`);
  lines.push(`Module id,${data.moduleId}`);
  lines.push('');
  lines.push('Summary — task assessments');
  lines.push(rowsToCsv(data.summaryTaskRows));
  lines.push('');
  lines.push('Expected IACs — task assessments');
  lines.push(rowsToCsv(data.expectedIacTaskRows));
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8' });
  saveAs(blob, data.filenameBase + '.csv');
}

export function downloadModuleAuditXlsx(data) {
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([['Module', data.moduleTitle], ['Module id', data.moduleId]]), 'Summary');
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(data.summaryTaskRows), 'Task coverage');
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(data.expectedIacTaskRows), 'IACs task');
  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([out], { type: 'application/octet-stream' }), data.filenameBase + '.xlsx');
}

export function downloadModuleAuditPdf(data) {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const margin = 40;
  let y = margin;
  const line = 14;
  const pageW = doc.internal.pageSize.getWidth();

  const addHeading = (t) => {
    if (y > doc.internal.pageSize.getHeight() - 60) {
      doc.addPage();
      y = margin;
    }
    doc.setFont(undefined, 'bold');
    doc.setFontSize(11);
    doc.text(t, margin, y);
    y += line + 4;
    doc.setFont(undefined, 'normal');
    doc.setFontSize(9);
  };

  const addPara = (t) => {
    const lines = doc.splitTextToSize(String(t || ''), pageW - 2 * margin);
    for (const ln of lines) {
      if (y > doc.internal.pageSize.getHeight() - 40) {
        doc.addPage();
        y = margin;
      }
      doc.text(ln, margin, y);
      y += line;
    }
    y += 6;
  };

  doc.setFontSize(14);
  doc.text('Assessment audit export', margin, y);
  y += line + 8;
  doc.setFontSize(10);
  addPara(`Module: ${data.moduleTitle} (id ${data.moduleId})`);
  addPara(`Exported: ${new Date().toISOString()}`);

  addHeading('Summary — task assessments');
  data.summaryTaskRows.forEach((row) => addPara(row.join(' | ')));

  addHeading('Expected IACs — task assessments');
  data.expectedIacTaskRows.forEach((row) => addPara(row.join(' | ')));

  doc.save(data.filenameBase + '.pdf');
}
